import React from 'react';
import { motion } from 'framer-motion';
import { X } from '@phosphor-icons/react';

/**
 * PageShell — Unified modal-style container used by ALL pages.
 * Matches the Feld 1 Identitaet design: blur backdrop, centered card, visible borders.
 * Works in both light and dark mode.
 */
const PageShell = ({ children, icon: Icon, iconColor = 'var(--accent-cyan)', title, subtitle, badge, onClose, maxWidth = 'max-w-2xl', testId }) => (
  <div className="min-h-screen flex items-start justify-center p-4 pt-8 pb-16"
    style={{ background: 'var(--bg-void)' }}>
    <motion.div
      initial={{ scale: 0.95, opacity: 0, y: 20 }}
      animate={{ scale: 1, opacity: 1, y: 0 }}
      transition={{ type: 'spring', damping: 25, stiffness: 300 }}
      className={`w-full ${maxWidth} relative`}
      style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-default)',
        borderRadius: '24px',
        boxShadow: '0 25px 60px rgba(0,0,0,0.12)',
      }}
      data-testid={testId}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-6" style={{ borderBottom: '1px solid var(--border-default)' }}>
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="hex-clip flex items-center justify-center" style={{ width: 40, height: 40, background: iconColor }}>
              <Icon size={20} weight="bold" color="#fff" />
            </div>
          )}
          <div>
            <h2 className="text-lg font-bold">{title}</h2>
            {subtitle && <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-3">
          {badge && (
            <span className="text-xs px-3 py-1 font-semibold" style={{ border: '1px solid var(--border-default)', borderRadius: '9999px', color: 'var(--text-secondary)' }}>
              {badge}
            </span>
          )}
          {onClose && (
            <button onClick={onClose} className="p-2 rounded-full transition-all hover:scale-110"
              style={{ color: 'var(--text-secondary)', background: 'transparent' }}
              data-testid="page-shell-close">
              <X size={18} />
            </button>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        {children}
      </div>
    </motion.div>
  </div>
);

export default PageShell;
